import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  LPCO Component Settings
 * !== LPCO Component Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/cpnt`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/cpnt`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/lpco/cfgn/cpnt/osci0203001s", label: "T_CPNT_SETT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0203001s: `${BASE.path}/osci0203001s`, // Register LPCO Component information   !== LPCO Component 등록  ==!
    osci0203002q: `${BASE.path}/osci0203002q`, // Register LPCO Component List  !== LPCO Component 목록  ==!
    osci0203003s: `${BASE.path}/osci0203003s`, // Register LPCO Component Detail  !== LPCO Component 상세  ==!
    osci0203004s: `${BASE.path}/osci0203004s`, // LPCO Component Modification  !== LPCO Component 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* LPCO Component list inquiry !== LPCO Component 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getAppDtl: (appFmId: any) => {
        return api.get(`${BASE.api}/${appFmId}`);
    },
    /* LPCO detailed inquiry !== LPCO Component 상세 조회 ==! */
    getLpcoCnptDtl: async (appFmId: any) => {
        return await api.get(`${BASE.api}/${appFmId}`);
    },
    /* Register LPCO information !== LPCO Component 등록 ==! */
    createAppCpnt: (data: any) => {
        console.log("createAppCpnt ", data);
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    /* Edit LPCO information !== LPCO Component 수정 ==! */
    saveAppCpnt: (appFmId: any, data: any) => {
        console.log("saveAppCpnt ", data);
        return api.put(`${BASE.api}/${appFmId}`, {
            ...data,
        });
    },
    /* Delete LPCO information !== LPCO Component 삭제 ==! */
    deleteAppCpnt: (appFmId: any) => {
        return api.delete(`${BASE.api}/${appFmId}`, {});
    },
};

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
/**
 * Component Setting > Register LPCO Components
 */
// LPCO Component Schema !== LPCO Component ==!
export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfoU",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA */,
        appCdNo: { type: "text", label: "L_APP_CD", required: false, edit: false } /* Application Code */,
        appNm: { type: "text", label: "L_APP_NM", required: true, maxLength: 100 } /* Application Name */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            required: true,
            area: "comnCd",
            comnCd: "OSC0113",
            excludes: ["SA"],
        } /* Application Type */,
        appKndCd: {
            type: "select",
            label: "L_APP_KND",
            required: true,
            area: "comnCd",
            comnCd: "OSC0114",
            excludes: ["X"],
        } /* Application Kind */,
        atcmTpCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0025",
            label: "L_DOC_TP_CD",
            popupSize: "lg",
        } /* Attachment Type Code !== 첨부문서 유형 코드 ==! */,
        appImexTpCd: {
            type: "select",
            label: "L_IMEX_CO_TP",
            required: true,
            options: [
                { label: "Importation", value: "IM" },
                { label: "Exportation", value: "EX" },
                { label: "All", value: "AL" },
            ],
        } /* Import/Export Type */,
        vldPridDays: {
            type: "number",
            required: true,
            min: 1,
        },
        /*Validity Period(Months) */
        aprvNoPtnCd: {
            type: "select",
            label: "L_LPCO_APRV_NO_TP",
            required: false,
            area: "comnCd",
            comnCd: "OSC0125",
        } /*  Approval Number PTN Code !== 승인_번호_패턴_코드 ==! */,
        aprvNoPtnValue: {
            type: "text",
            label: "L_LPCO_APRV_NO_PTN_VALUE",
            maxLength: 30,
        } /* Approval Number Pattern Values !== 승인_번호_패턴_값 ==! */,
        daysUtCd: {
            type: "select",
            required: true,
            area: "comnCd",
            comnCd: "OSC0126",
        } /* Days Unit Type Code */,
        intfYn: {
            type: "select",
            label: "L_INTF_YN",
            required: true,
            area: "comnCd",
            comnCd: "OSC0100",
            defaultValue: "N",
            select: false,
        } /* Interface Yn !== 연계 여부 ==! */,
        useYn: {
            type: "select",
            label: "L_USE_YN",
            required: true,
            area: "comnCd",
            comnCd: "OSC0100",
            defaultValue: "Y",
            select: false,
        } /*Use Yn  */,
    },
};

export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfoR",
    schema: {
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA */,
        appCdNo: { type: "text", label: "L_APP_CD", edit: false } /* Application Code */,
        appNm: { type: "text", label: "L_APP_NM", edit: false } /* Application Name */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            edit: false,
        } /* Application Type */,
        appKndCd: {
            type: "select",
            label: "L_APP_KND",
            edit: false,
            area: "comnCd",
            comnCd: "OSC0114",
            excludes: ["X"],
        } /* Application Kind */,
        atcmTpCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0025",
            label: "L_DOC_TP_CD",
            popupSize: "lg",
            edit: false,
        } /* Attachment Type Code !== 첨부문서 유형 코드 ==! */,
        appImexTpCd: {
            type: "select",
            label: "L_IMEX_CO_TP",
            edit: false,
            options: [
                { label: "Importation", value: "IM" },
                { label: "Exportation", value: "EX" },
                { label: "All", value: "AL" },
            ],
        } /* Import/Export Type */,
        vldPridDays: {
            type: "number",
            edit: false,
        },
        /*Validity Period(Months) */
        aprvNoPtnCd: {
            type: "select",
            label: "L_LPCO_APRV_NO_TP",
            edit: false,
            area: "comnCd",
            comnCd: "OSC0125",
        } /*  Approval Number PTN Code !== 승인_번호_패턴_코드 ==! */,
        aprvNoPtnValue: {
            type: "text",
            label: "L_LPCO_APRV_NO_PTN_VALUE",
            edit: false,
        } /* Approval Number Pattern Values !== 승인_번호_패턴_값 ==! */,
        daysUtCd: {
            type: "select",
            area: "comnCd",
            comnCd: "OSC0126",
            required: false,
            edit: false,
            viewType: "label",
        } /* Days Unit Type Code */,
        intfYn: {
            type: "select",
            label: "L_INTF_YN",
            edit: false,
            area: "comnCd",
            comnCd: "OSC0100",
            select: false,
        } /* Interface Yn !== 연계 여부 ==! */,
        useYn: {
            type: "select",
            label: "L_USE_YN",
            edit: false,
            area: "comnCd",
            comnCd: "OSC0100",
            defaultValue: "Y",
            select: false,
        } /*Use Yn  */,
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

/**
 * Component Setting > LPCO LIST
 */
// LPCO Component Search Schema !== LPCO Component Search  ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: { ...COMN_SF_LPCO_SRCH },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_NO_CPNT", binding: "cnt", width: "15%" }] } /* Number of components */,
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "cnt", type: "number", align: "center" }] },
    ],
};

/**
 * LPCO COMPONENT DETAIL
 */

// LPCO Component Schema !== LPCO Component ==!
export const SG_LPCO_CPNT_LIST_U: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 250,
    },
    head: [
        { cells: [{ header: "L_CPNT_NM", binding: "cpntCd", width: "*" }] } /* Component Name */,
        { cells: [{ header: "L_DESC", binding: "cpntDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "cpntCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0116",
                    area: "comnCd",
                    excludes: ["DCL", "ATC", "PAY", "MSG", "CON"],
                    required: true,
                },
            ],
        },
        { cells: [{ binding: "cpntDesc", align: "left", maxLength: 2000 }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_CPNT_LIST_R: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        { cells: [{ header: "L_CPNT_NM", binding: "cpntNm", width: "*" }] } /* Component Name */,
        { cells: [{ header: "L_DESC", binding: "cpntDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "cpntCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0116",
                    area: "comnCd",
                    excludes: ["DCL", "ATC", "PAY", "MSG", "CON"],
                },
            ],
        },
        { cells: [{ binding: "cpntDesc", align: "left" }] },
    ],
};
